import { FC } from "react";
import { useResourceRegister } from "@/utils/resourceRegister";

const EncryptionDashboardResourceRegister: FC = () => {
  useResourceRegister({ name: 'encryption/dashboard' })
  useResourceRegister({ name: 'mappings-update' })
  useResourceRegister({ name: 'pending-tables' })
  useResourceRegister({ name: 'pending-collections' })

  return (
    null
  )
}

export default EncryptionDashboardResourceRegister;
